module.exports = __webpack_public_path__ + "static/img/IMG_20160224_120608.ea2b8ee0.jpg";